export enum GridViews {
  'col-2' = 'col-2',
  'col-3' = 'col-3',
  'col-12' = 'col-12',
}
